// extracted by mini-css-extract-plugin
export default {"card":"G4-z"};